import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  invert?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  invert = false
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5
  }} className={`${align === 'center' ? 'mx-auto text-center' : 'text-left'} max-w-2xl`} data-id="element-168" data-mp="3k0f7zhkr3p7c">
      {eyebrow && <span className={`inline-block rounded-full px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide ${invert ? 'bg-white/15 text-yellow-brand' : 'bg-green-soft text-green-deep'}`} data-id="element-169" data-mp="1uadend0uo5o">
          {eyebrow}
        </span>}
      <h2 className={`mt-4 font-display text-3xl font-black leading-tight sm:text-4xl lg:text-[2.75rem] ${invert ? 'text-white' : 'text-green-deep'}`} data-id="element-170" data-mp="zapx1fn64njx">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${invert ? 'text-white/80' : 'text-[#4A5748]'}`} data-id="element-171" data-mp="1o91grgsc9ihi">
          {subtitle}
        </p>}
    </motion.div>;
}